import { render, staticRenderFns } from "./my-upload.vue?vue&type=template&id=1c93dafe&scoped=true&"
import script from "./my-upload.vue?vue&type=script&lang=js&"
export * from "./my-upload.vue?vue&type=script&lang=js&"
import style0 from "./my-upload.vue?vue&type=style&index=0&id=1c93dafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c93dafe",
  null
  
)

export default component.exports